import { Key, storage } from '@soluto-private/mx-context';
import { LOCALES } from './locales-languages';
import { PARTNERS_LOCALES } from './partner-locales';
var DEFAULT_LOCALE = 'en-US';
var getSessionPartner = function () { return storage.get(Key.Client); };
var getSessionLocale = function () { return storage.get(Key.Language); };
var localeToLanguage = function (localeCode) {
    if (!LOCALES[localeCode]) {
        console.warn("i18n - language is missing for locale", { localeCode: localeCode });
        return;
    }
    var _a = LOCALES[localeCode], displayLang = _a[0], lang = _a[1];
    return { code: localeCode, lang: lang, displayLang: displayLang };
};
var getSupportedLocales = function (partner) {
    var _a;
    if (!partner)
        return [DEFAULT_LOCALE];
    var supportedLocales = (_a = PARTNERS_LOCALES[partner]) === null || _a === void 0 ? void 0 : _a.supportedLocales;
    if (!supportedLocales) {
        console.warn("i18n - supported locales are missing for partner, setting default locale", {
            defaultLocale: DEFAULT_LOCALE,
            partner: partner
        });
        return [DEFAULT_LOCALE];
    }
    return supportedLocales;
};
var getDefaultLocale = function (partner) {
    var _a;
    if (!partner)
        return DEFAULT_LOCALE;
    var defaultLocale = (_a = PARTNERS_LOCALES[partner]) === null || _a === void 0 ? void 0 : _a.defaultLocale;
    if (!defaultLocale) {
        console.warn("i18n - default locale is missing for partner, setting default locale", {
            defaultLocale: DEFAULT_LOCALE,
            partner: partner
        });
        return DEFAULT_LOCALE;
    }
    return defaultLocale;
};
var getPartnerLanguages = function () {
    var partner = getSessionPartner();
    var supportedLocales = getSupportedLocales(partner);
    var partnerLocales = supportedLocales.map(localeToLanguage).filter(function (locale) { return locale; });
    return partnerLocales;
};
var setSessionLocale = function (localeCode) {
    var partner = getSessionPartner();
    var supportedLocales = getSupportedLocales(partner);
    if (supportedLocales.includes(localeCode))
        storage.set(Key.Language, localeCode);
    else
        console.warn("i18n - locale is not supported by partner", { localeCode: localeCode, partner: partner });
};
var setPartnerLocale = function () {
    var partner = getSessionPartner();
    var currentLocale = getSessionLocale();
    var supportedLocales = getSupportedLocales(partner);
    var isSupported = function (locale) { return supportedLocales.includes(locale); };
    var browserLocale = navigator.language;
    if (isSupported(currentLocale)) {
        storage.set(Key.Language, currentLocale);
    }
    else if (isSupported(browserLocale)) {
        storage.set(Key.Language, browserLocale);
    }
    else {
        storage.set(Key.Language, getDefaultLocale(partner));
    }
};
export { getPartnerLanguages, setPartnerLocale, getSessionLocale, setSessionLocale };
